import { render, staticRenderFns } from "./FontWeightProperty.vue?vue&type=template&id=2e745dab&"
import script from "./FontWeightProperty.vue?vue&type=script&lang=js&"
export * from "./FontWeightProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports